export const JWT_KEY = 'jwt';

export const MIN_MOVE_IN_OFFSET_DAYS = 3;

// 예약 가능 범위(일). 입주희망일이 오늘+이 값을 초과하면 예약 대신 Waitlist 대상.
// 백엔드가 내려주는 reservationWindowDays 가 없을 때의 fallback (매물 상세·찜 페이지 공용)
export const RESERVATION_WINDOW_DAYS = 50;
